import { Directive } from "@angular/core";
import { AbstractControl, AsyncValidator, AsyncValidatorFn, NG_ASYNC_VALIDATORS, ValidationErrors, ValidatorFn } from "@angular/forms";
import { EventService } from "../../vortex/services/event.service";
import { catchError, map, Observable, of } from "rxjs";
import { MainModel } from "../model/MainModel";

export class EventCodeValidator {
  static createValidator(
    eventService:EventService,
    model:MainModel
    ): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return eventService.validateEventCode(control.value, model.selectedCampaign()?.campaignId||0)
        .pipe( 
          map( (result) => {
            return null 
            }
          ) ,
          catchError( error => of({eventCodeExists: true}) )
        )
    };
  }
}